import { useTranslation } from 'react-i18next';
import React, { useContext } from 'react';
import { isMobile } from 'react-device-detect';
import { upgradeAccountScreens } from '../constant';
import MainBodyLayout from '../partials/MainBodyLayout';
import { UpgradeAccountContext } from '../../../../../contexts/settings/upgradeAccount/context';

const StartUpgrade = () => {
  const { t: translate } = useTranslation();

  const { openScreen } = useContext(UpgradeAccountContext);

  const renderFooter = () => (
    <button
      className="btn btn-primary py-3 w-100"
      type="button"
      onClick={() => openScreen(upgradeAccountScreens.UPGRADE_LEVEL)}>
      {translate('continue_btn_title')}
    </button>
  );

  return (
    <MainBodyLayout>
      <div className="d-flex flex-column justify-content-center align-items-center">
        <img src="./assets/images/upgrade.png" alt="Upgrade Account" />
        <p className="text-f4 text-dark text-bold mt-4">
          {translate('start_upgrade_account_title')}
        </p>
        <p className="text-f5 text-shadow text-center mt-3">
          {translate('start_upgrade_account_subtitle')}
        </p>
        <p className="text-f5 text-shadow text-center mt-3">
          {translate('start_upgrade_account_note')}
        </p>
      </div>
      <div
        className={`d-flex flex-row mt-5 pt-3 ${
          isMobile ? 'position-fixed w-100 bg-light pb-3 px-2 border-0' : 'mx-2 px-5'
        }`}
        style={{ bottom: '0%', left: '0%', zIndex: 100 }}>
        {renderFooter()}
      </div>
    </MainBodyLayout>
  );
};

export default StartUpgrade;
